export class RouteQuery {
    get(_name) {
        return 'todo';
    }
}
